import { render, staticRenderFns } from "./Grower.vue?vue&type=template&id=8aab4400&scoped=true"
import script from "./Grower.vue?vue&type=script&lang=js"
export * from "./Grower.vue?vue&type=script&lang=js"
import style0 from "./Grower.vue?vue&type=style&index=0&id=8aab4400&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aab4400",
  null
  
)

export default component.exports